module.exports = __webpack_public_path__ + "static/media/rescuerangers.3f6c8f3f.mp3";